export default "__VITE_ASSET__roPrad0w__"